// removed by extract-text-webpack-plugin
module.exports = {"app":"_2b-y7ud7OD5aHpR3jl3ra5","repository":"_1SdX4YgWCclPB_t5LXZmgF","answer":"_1l0AHA2xI1QHr_6LIKXvHr","answerCounting":"cTzPXzEEatFdUt76PO7lj","answerDone":"_1DbqfLWRswSARuchKDD8He","countdown":"ZU03gSUKvgqCcE6gBrI8U","counter":"xdOAramPhExri7IjaELSz","counterCount":"_2358KVzd_IJXz4gzdRxQT","counterPeriod":"ndwIZ__NZ5v5Ob0Dj7Whb","background":"_22MYNo86osyK_aVeia5prT","backgroundDone":"_238XDIIdj1rpOj3lVe9Zb_","backgroundCounting":"_1jibkc9wLL6-xfxI7p77cx","loading":"_3xxyV2zXySg25pnpZOWowf","rotating":"_32aNl95jW8p9v1piHXpUdu"};


//////////////////
// WEBPACK FOOTER
// ./src/styles.scss
// module id = 18
// module chunks = 0